import React from "react";
import { ShieldCheck } from "lucide-react";
import { ACCREDITATIONS } from "../mock";

const Marquee = () => {
  const items = [...ACCREDITATIONS, ...ACCREDITATIONS];
  return (
    <section className="py-10 bg-[#0a0f1c] border-y border-white/5 overflow-hidden">
      <div className="text-center text-[11.5px] tracking-[0.22em] uppercase text-amber-300 font-medium">
        Accredited · Awarded · Trusted
      </div>
      <div className="mt-6 marquee-track" aria-hidden="true">
        {items.map((label, i) => (
          <div
            key={`${label}-${i}`}
            className="flex items-center gap-2.5 px-7 text-slate-300 text-[14px] whitespace-nowrap"
          >
            <ShieldCheck className="h-4 w-4 text-emerald-400" />
            <span>{label}</span>
            <span className="text-slate-600 ml-1">•</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
